import { ApiMethod } from '../types/api.types';
import { z } from 'zod';

export const API_HUBSPOT = {
    GET_ID_TOKEN: {
        method: ApiMethod.GET,
        path: '/hubspot-identification-token',
        handlerMethod: 'getIdentificationToken',
        zod: {},
        responses: {
            200: {
                description: 'The hubspot identification token',
                schema: z.object({
                    identificationEmail: z.string(),
                    identificationToken: z.string()
                })
            }
        }
    }
} as const;
